import { Component, HostListener,OnInit, Inject } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss']
})
export class SmsComponent implements OnInit {
  constructor(@Inject(DOCUMENT) document) {

  }
  adv: boolean = true;
  partner: boolean = false;
  isService: boolean = true;
  showAdv(){
      this.adv = true;
      this.partner = false;
  }
  showPartner(){
    this.adv = false;
    this.partner = true;
  }
  ngOnInit() {
    window.scrollTo(0, 0)
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {

    if (window.pageYOffset > 30) {
      let element2 = document.getElementById('fixed-right');
      element2.classList.add('top-0');

    } else {
      let element2 = document.getElementById('fixed-right');
      element2.classList.remove('top-0');
    }
  }
}
